/* eslint-disable */
import $ from "jquery";
import Selectize from "selectize/dist/js/standalone/selectize.min.js";

// Selectize plugin to display a message
// if no results are loaded/returned
Selectize.define("empty_result", function(options) {
  // Keep reference to parent selectize instance
  const selectize = this;
  // Merge options with defaults
  options = $.extend(
    {
      message() {
        return "";
      },
      empty() {
        return "";
      }
    },
    options
  );

  // Current query terms
  let query = "";

  // Bypassing the .hasOptions checks
  // that selectize does internally
  this.forceOpen = function() {
    this.isOpen = true;
    this.$dropdown.css({ visibility: "hidden", display: "block" });
    this.positionDropdown();
    this.$dropdown.css({ visibility: "visible" });
    return this.trigger("dropdown_open", this.$dropdown);
  };

  return (this.setup = (function() {
    const original = selectize.setup;
    return function() {
      original.apply(this, arguments);
      const self = this;

      // Force toggle the placeholder to vanish
      // as soon as input gains focus, see GH issue #159
      const togglePlaceholder = function() {
        const ctrl = self.$control_input;
        if (!self.$control.hasClass("focus")) {
          ctrl.attr("placeholder", self.settings.placeholder);
        } else {
          ctrl.attr("placeholder", "");
        }
        return ctrl.trigger("update");
      };

      // Show a message if no options are available
      const showEmpty = function() {
        togglePlaceholder();
        if (!Object.keys(self.options).length) {
          self.$dropdown_content.html(options.empty());
          if (self.$control.hasClass("focus")) {
            return self.forceOpen();
          }
        }
      };

      selectize.$control_input.on("focus", () => setTimeout(showEmpty, 100));

      selectize.$input.on("focus", () => setTimeout(showEmpty, 100));

      selectize.on("dropdown_close", () => setTimeout(showEmpty, 100));

      // Keep track of the query
      // NOTE: We could probably do this via
      // the .lastValue property, but seems unreliable
      selectize.on("type", str => (query = str));

      // Hook into load events to determine
      // if we got results back or if we need to show the message
      selectize.on("load", function(data) {
        if (data.length > 0 || query.length < 3) {
          return;
        }
        this.$dropdown_content.html(options.message(query));
        return this.forceOpen();
      });

      // issue #193: intercept 'enter' from ipad and send it through
      // as a click, from any dropdown (the button will not be enabled if
      // the current search parameters are invalid)
      return selectize.$control_input.on("keydown", e => {
        if (e.keyCode === 13) {
          return Ember.run.next(() =>
            App.$(".rjp button[type=submit]:visible:enabled").click()
          );
        }
      });
    };
  })());
});
/* eslint-enable */
